import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CSSTransitionGroup } from 'react-transition-group';

import Notification from './Notification';

import './Notifications.css';

export default function Notifications({ className, notifications, fixed, orientation }) {
  return (
    <div
      className={classnames('Notifications', className, {
        'Notifications--fixed': fixed,
        'Notifications--right': orientation === 'right',
        'Notifications--left': orientation === 'left',
      })}
    >
      <CSSTransitionGroup
        component="div"
        className={classnames('Notifications__list', {
          'Notifications__list--right': orientation === 'right',
          'Notifications__list--left': orientation === 'left',
        })}
        transitionName="Notification"
        transitionEnterTimeout={1000}
        transitionLeaveTimeout={500}
      >
        {notifications.map(notification => (
          <Notification
            key={`notification_${notification.id}`}
            text={notification.text}
            icon={notification.icon}
          />
        ))}
      </CSSTransitionGroup>
    </div>
  );
}

Notifications.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      icon: PropTypes.string,
    }),
  ),
  fixed: PropTypes.bool,
  orientation: PropTypes.oneOf(['right', 'left']),
};
Notifications.defaultProps = {
  className: null,
  notifications: [],
  fixed: false,
  orientation: 'right',
};



// WEBPACK FOOTER //
// ../ui-components/components/Notifications/Notifications.jsx